<footer class="footer">
  <div class="footer-content">
    <div *ngIf="environment.int" class="translation-toggle">
      <span class="link-item">Translation keys</span>
      <app-toggle-switch
        (change)="onTranslationKeysChange($event)"
        [activated]="storage.getItem('translationKeys') === 'true'"
      >
      </app-toggle-switch>
    </div>
    <div *ngIf="environment.int" class="divider"></div>
    <a [href]="footerUrls.privacyPolicyUrl" class="link-item" target="_blank">{{
      "FOOTER.PRIVACY_POLICY" | translate
    }}</a>
    <div class="divider"></div>
    <a [href]="footerUrls.legalNoticeUrl" class="link-item" target="_blank">{{
      "FOOTER.LEGAL_NOTICE" | translate
    }}</a>
  </div>
</footer>
